import { useMutation } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { useToast } from '@navegasistemas/dls-navega-rjs'
import { authService } from '@/features/auth/services/auth.service'
import { useAuthStore } from '@/store/auth-store'

/**
 * Encerra todas as sessões do usuário (RF11) — mesma política de melhor
 * esforço do `useLogout` (RF10): a sessão local é sempre limpa e o usuário
 * sempre é redirecionado para `/login` em `onSettled`, mesmo se a chamada ao
 * backend falhar, já que o objetivo do usuário é sair de todo jeito. O toast
 * de sucesso é disparado em paralelo, sem bloquear o redirecionamento.
 */
export function useLogoutAll() {
  const navigate = useNavigate()
  const { accessToken, clearAuth } = useAuthStore()
  const { toast } = useToast()

  const mutation = useMutation({
    mutationFn: () => authService.logoutAll(accessToken!),
    onSuccess: () => {
      toast({ variant: 'success', message: 'Todas as sessões foram encerradas.' })
    },
    onSettled: () => {
      clearAuth()
      navigate('/login')
    },
  })

  return {
    logoutAll: mutation.mutate,
    isPending: mutation.isPending,
  }
}
